module.exports = __webpack_public_path__ + "static/img/download-ios.690fc01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download-ios.png
// module id = T/g0
// module chunks = 114